//C:\xampp\htdocs\pms2\frontend\src\components\sales\Cart.tsx
import React from "react";
import { SaleItem } from "../../types/sale";

interface CartProps {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

export default function Cart({ cart, setCart }: CartProps) {
  const updateQty = (id: number, qty: number) => {
    setCart(
      cart.map((i) =>
        i.product_id === id ? { ...i, quantity: qty } : i
      )
    );
  };

  const remove = (id: number) => {
    setCart(cart.filter((i) => i.product_id !== id));
  };

  const total = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return (
    <div className="card p-3">
      <h5>Cart</h5>

      {cart.map((i) => (
        <div key={i.product_id} className="d-flex mb-2">
          <span className="flex-grow-1">
            {i.name} ({i.price} ETB)
          </span>

          <input
            type="number"
            value={i.quantity}
            min={1}
            onChange={(e) => updateQty(i.product_id, +e.target.value)}
            style={{ width: 60 }}
          />

          <button
            className="btn btn-danger btn-sm ms-2"
            onClick={() => remove(i.product_id)}
          >
            X
          </button>
        </div>
      ))}

      <hr />
      <strong>Total: {total} ETB</strong>
    </div>
  );
}
